export default __webpack_public_path__ + "static/media/Map3bhk.ff374fc8.webp";